"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeBoards = void 0;
const board_1 = require("./board");
const position_1 = require("./position");
const rotateGridPosition_1 = require("./rotateGridPosition");
const mergeBoards = (id, home, away) => {
    if (home.width !== away.width || home.height !== away.height) {
        throw Error("Trying to merge odd-sized boards");
    }
    const newBoard = new board_1.Board(home.width, home.height * 2);
    const differenceWidth = newBoard.width - home.width;
    const differenceHeight = newBoard.height - home.height;
    for (const piece of home.getAllPieces()) {
        newBoard.setPiece(piece.id, piece.x + differenceWidth, piece.y + differenceHeight);
    }
    for (const piece of away.getAllPieces()) {
        const position = (0, position_1.packPosition)(piece.x + differenceWidth, piece.y + differenceHeight);
        const newPos = (0, rotateGridPosition_1.rotateGridPosition)({ width: newBoard.width, height: newBoard.height }, position);
        newBoard.setPiece(piece.id, (0, position_1.unpackX)(newPos), (0, position_1.unpackY)(newPos));
    }
    return newBoard;
};
exports.mergeBoards = mergeBoards;
